import { SelectProps } from "@cofano/cck/Select/Select";
import { TimeUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const TimeUnitSelect = ({ value, onChange, options }: Omit<SelectProps<TimeUnit, false>, "fetchOptions"> & { options?: TimeUnit[] }) => {
	const fetchOptions = options ? options : Object.values(TimeUnit);

	return (
		<Select
			fetchOptions={fetchOptions}
			getOptionLabel={(option) => intl.formatMessage({ id: `TIME_UNIT_PER_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default TimeUnitSelect;
